import React, { useMemo } from 'react';
import { Tooltip } from 'react-tooltip';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';
//components
import IndicatorRefreshButton from '../IndicatorRefreshButton';
import { Column, Row } from 'components/Layout/Grid';
import { Visibility } from 'components/Visibility';
import Loading from 'components/Loading';
import Text from 'components/Text';
//models
import { IQuoteManagement } from '../models/quoteManagement';
//assets
import pendingMoneyError from "img/pending-money-error-icon.svg";
//styles
import './styles.scss';
import { colors } from '../../styles/colors';

const COLORS = {
  ALERT: colors.alert,
  WARNING: colors.warning,
  DEFAULT: colors.blue,
} as const;

const getIndicatorColor = (
  isReviewRateOrChangeRatePercentage: boolean,
  value: string | number | undefined,
  typeCard: string
): string => {
  if (isReviewRateOrChangeRatePercentage) {
    return value && Number(value) < 50 ? COLORS.ALERT : COLORS.DEFAULT;
  }
  
  if (typeCard === 'warning') return COLORS.WARNING;
  if (typeCard === 'alert') return COLORS.ALERT;
  
  return COLORS.DEFAULT;
};

const ManagementIndicator: React.FC<IQuoteManagement> = ({
  data,
  showClickDetails = false,
  showErrorIcon = false,
  isReviewRateOrChangeRatePercentage = false,
  onClick,
}) => {
  const { error, loading, title, value, typeCard = 'default', typeValue = 'number' } = data;


  const selectedFilterCard = useSelector((stateFilter: RootState) => stateFilter.quotesDashboard?.selectedFilterCard);

  const isSelected = selectedFilterCard === data.title;

  const textColor = getIndicatorColor(isReviewRateOrChangeRatePercentage, value, typeCard);

  return (
      <div
        className={`mt-2 mb-3 custom-management-indicators-filter flex-row ${isSelected ? 'selected' : ''}`}
      >
        <Column
          className={`bg-white mr-md-0 indicator ${isSelected ? 'selected' : ''}`}
          style={{width: '100%'}}
          onClick={() => onClick?.()}
        >
          <Column className="title-subtitle">
            <Text size={16} className={`${isSelected ? 'custom-title' : 'subtitle'} color-blueDark`}>
              {title}
            </Text>
          </Column>

          <Visibility visible={!error && !loading}>
            <Row className="align-items-center py-1">
              <Visibility visible={showErrorIcon}>
                <img className="mr-1" src={pendingMoneyError} alt="Ícone de alerta" width={30} height={30} 
                  style={{ marginTop: "0.5rem" }} />
              </Visibility>
              <Text size={36} className="font-bold" color={textColor}>
                {typeValue === 'percent' ? `${Number(value).toFixed(0)} %` : value}
              </Text>
            </Row>
          </Visibility>

          <Visibility visible={error}>
            <Row className="indicatorLoading">
              <IndicatorRefreshButton onReload={() => {}} refreshSize={"20px"} />
            </Row>
          </Visibility>
          
          <Visibility visible={loading}>
            <Row className="indicatorLoading">
              <Loading onlySpinner />
            </Row>
          </Visibility>

          <Visibility visible={showClickDetails}> 
            <div className="w-100">
              <Text size={12} className="text-right" color="#858585">Clique para ver detalhes</Text>
            </div>
          </Visibility>
        </Column>
      </div>
  );
};

export default ManagementIndicator;
